import React, { useContext, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { CustomText } from '@/components/CustomText';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { Image, ImageSource, ImageStyle } from 'expo-image';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "90%",
    gap: 20,
    alignItems: 'center',
    alignSelf: 'center',
  },
  headerIcon: {
    width: 24,
    height: 24,
  },
  bubbleContainer: {
    backgroundColor: '#a8a8a8',
    padding: 6,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
  },
  nonBubbleContainer: {
    padding: 6,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
  },
  w25h25: {
    width: 25,
    height: 25,
  },
  w20h21mh2mv2: { 
    width: 20,
    height: 21,
    marginHorizontal: 2,
    marginVertical: 2,
  },
  w15h16mh4: {
    width: 15,
    height: 16,
    marginHorizontal: 4,
  },
  w23h19mh2mv2: {
    width: 23,
    height: 19,
    marginHorizontal: 1,
    marginVertical: 2,
  },
  w24h24: {
    width: 24,
    height: 24,
  },
  flexRowJustifyCenter: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  w20h17mh2mv4: {
    width: 20,
    height: 17,
    marginHorizontal: 2,
    marginVertical: 4,
  },
  mt20: {
    marginTop: 20,
  },
  w15h16mh5mv4: {
    width: 15,
    height: 15,
    marginHorizontal: 5,
    marginVertical: 4,
  },
  w19h19mh3mv3: {
    width: 19,
    height: 19,
    marginHorizontal: 3,
    marginVertical: 3,
  },
});

type Props = {
  id?: number,
};

type ImageInfo = {
  source: ImageSource,
  style: ImageStyle,
};

function getRandomIntInclusive(min: number, max: number): number {
  const minCeiled: number = Math.ceil(min);
  const maxFloored: number = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1)) + minCeiled;
}

const MAX_ID = 8;

const images = new Map<number, ImageInfo>([
  [1, { source: require('@/assets/images/butterfly10.gif'), style: styles.w25h25 }],
  [2, { source: require('@/assets/images/butterfly3.gif'), style: styles.w20h21mh2mv2 }],
  [3, { source: require('@/assets/images/butterfly4.gif'), style: styles.w15h16mh5mv4 }],
  [4, { source: require('@/assets/images/butterfly6.gif'), style: styles.w23h19mh2mv2 }],
  [5, { source: require('@/assets/images/butterfly9.gif'), style: styles.w24h24 }],
  [6, { source: require('@/assets/images/butterfly7.gif'), style: styles.w20h17mh2mv4 }],
  [7, { source: require('@/assets/images/butterfly5.gif'), style: styles.w15h16mh5mv4 }],
  [MAX_ID, { source: require('@/assets/images/butterfly8.gif'), style: styles.w19h19mh3mv3 }],
]);

export default function Bullet({ id = -1 }: Props) : React.ReactNode {
  let finalId = id;
  if (finalId == -1 || finalId > MAX_ID) {
    finalId = getRandomIntInclusive(1, MAX_ID);
  }
  return <Image source={images.get(finalId)?.source} style={images.get(finalId)?.style} />;
};
